/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

export const errorAboutMeConfig = {
  updateKyc: {
    title: 'Uh oh.',
    icon: 'https://s3.ap-south-1.amazonaws.com/io.vlinder.illustrations/sad-face-fhp.png',
    description: [
      'Know Your Customer (KYC) Status update failed',
      'Keep calm and try again',
    ],
    acknowledgementButtonText: 'Close',
  },
  getPageContent: {
    title: 'Uh oh.',
    icon: 'https://s3.ap-south-1.amazonaws.com/io.vlinder.illustrations/sad-face-fhp.png',
    description: ['Something wierd happened', 'Keep calm and try again'],
    acknowledgementButtonText: 'Close',
  },
  updatePayment: {
    title: 'Uh oh.',
    icon: 'https://s3.ap-south-1.amazonaws.com/io.vlinder.illustrations/sad-face-fhp.png',
    description: ['Update payment status failed', 'Keep calm and try again'],
    acknowledgementButtonText: 'Close',
  },
};
